// @ts-strict-ignore
import { component } from "picoapp";
import {
  MAIN_PRODUCT_CLASS,
  SUPPLEMENTAL_PRODUCT_CLASS,
} from "../../constants";
import {
  type OPProduct,
  type OPProductVariant,
  type Context,
  type ImageMedia,
} from "../../state";
import { updatePictureElement } from "../../utilities";
import {
  TablescapeContext,
  TablescapeEvent,
} from "@root/tablescape/utilities/tablescapeContext";

export const productHighlightsAccordion = component<Context>(
  async (node, context) => {
    TablescapeContext.on(
      TablescapeEvent.PRODUCT_HERO_VARIANT_SELECTED,
      (data?: {
        productHero: {
          product?: OPProduct;
          selectedVariant?: OPProductVariant;
        };
      }) => {
        const thumbnailImageElements =
          node.querySelectorAll<HTMLPictureElement>(
            "picture.product-thumbnail"
          );
        const selectedVariant = data?.productHero.selectedVariant;
        const product = data?.productHero.product;

        if (selectedVariant?.variantFixedBundleComponents) {
          const variantBundleComponentImages =
            selectedVariant.variantFixedBundleComponents.map(
              (variant) => variant.image
            );
          thumbnailImageElements.forEach((thumbnailImageElement, index) => {
            if (
              thumbnailImageElement &&
              variantBundleComponentImages?.[index]
            ) {
              updatePictureElement({
                element: thumbnailImageElement,
                source: variantBundleComponentImages[index],
              });
            }
          });
        } else if (product?.productFixedBundleComponents) {
          const productBundleComponentImages =
            product.productFixedBundleComponents.map(
              (product) => product.featuredImage
            );

          thumbnailImageElements.forEach((thumbnailImageElement, index) => {
            if (
              thumbnailImageElement &&
              productBundleComponentImages?.[index]
            ) {
              updatePictureElement({
                element: thumbnailImageElement,
                source: productBundleComponentImages[index],
              });
            }
          });
        }
      }
    );

    // TODO: Remove below when fully migrated to React ProductHero
    context.on(
      "tbsp:variant-selected",
      async ({
        selectedVariant: {
          mainProduct,
          media,
          supplementalProduct,
          variantBundleComponentImages,
        },
      }) => {
        node.setAttribute(
          "data-variant-bundle",
          String(!!variantBundleComponentImages)
        );

        const isVariantBundle = node.dataset.variantBundle === "true";

        if (isVariantBundle) {
          const thumbnailImageElements =
            node.querySelectorAll<HTMLPictureElement>(
              "picture.product-thumbnail"
            );

          thumbnailImageElements.forEach((thumbnailImageElement, index) => {
            if (
              thumbnailImageElement &&
              variantBundleComponentImages?.[index]
            ) {
              updatePictureElement({
                element: thumbnailImageElement,
                source: variantBundleComponentImages[index].image,
              });
            }
          });
        } else {
          const mainThumbnailImageElement =
            node.querySelector<HTMLPictureElement>(
              `picture.${MAIN_PRODUCT_CLASS}`
            );
          const supplementalThumbnailImageElement =
            node.querySelector<HTMLPictureElement>(
              `picture.${SUPPLEMENTAL_PRODUCT_CLASS}`
            );

          let targetEl: HTMLPictureElement | null = null;

          if (mainProduct) {
            targetEl = mainThumbnailImageElement;
          } else if (supplementalProduct) {
            targetEl = supplementalThumbnailImageElement;
          }

          if (targetEl) {
            updatePictureElement({
              element: targetEl,
              source: media.find(
                (media): media is ImageMedia => media.contentType === "IMAGE"
              ).image,
            });
          }
        }
      }
    );
  }
);
